// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3gn4Y","rootSmall":"AddTileButton_rootSmall__2q9tx"};